import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/views/Login.vue';
import Roles from '@/views/Roles.vue';
import createRoles from '@/views/CreateRoles.vue';
import CreateMenus from '@/views/CreateMenus.vue';
import Profile from '@/views/Profile.vue';
import Menus from '@/views/Menus.vue';
import MenuAccess from '@/views/MenuAccessRoles.vue';
import Users from '@/views/Users.vue';
import fasciaGroups from '@/views/FasciasGroups.vue';
import CreatiafasciaGroup from '@/views/CreateFasciaGroup.vue';
import fascias from '@/views/Fascias.vue';
import categoryList from '@/views/CategoryList.vue';
import Createfascia from '@/views/CreateFascia.vue';
import CreateCategory from '@/views/CreateCategory.vue';
import CreateFT from '@/views/CreateFasciawiseTemplates.vue';
import FasciawiseTemplates from '@/views/FasciawiseTemplates.vue';
import CustomMailerTemplates from '@/views/CustomMailer.vue';
import CreateCustomMailer from '@/views/CreateCustomMailer.vue';
import PrepareMailers from '@/views/PrepareMailers.vue';
import CreateMailer from '@/views/CreateMailer.vue';
import SliceToMailer from '@/views/SliceToMailer.vue';
import InvalidAccess from '@/views/InvalidAccess.vue';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  hash: false,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'prepareMailers' },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/roles',
      name: 'roles',
      component: Roles,
    },
    {
      path: '/createRoles/*',
      name: 'createRoles',
      component: createRoles,
    },
    {
      path: '/createMenus/*',
      name: 'createMenus',
      component: CreateMenus,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/menus',
      name: 'menus',
      component: Menus,
    },
    {
      path: '/rolesMenuAccess',
      name: 'rolesMenuAccess',
      component: MenuAccess,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
    },
    {
      path: '/fasciaGroups',
      name: 'fasciaGroups',
      component: fasciaGroups,
    },
    {
      path: '/createfasciaGroup/*',
      name: 'createfasciaGroup',
      component: CreatiafasciaGroup,
    },
    {
      path: '/fasciasList/',
      name: 'fasciasList',
      component: fascias,
    },
    {
      path: '/createfascia/*',
      name: 'createfascia',
      component: Createfascia,
    },
    {
      path: '/createfasciawiseTemplate/*',
      name: 'createfasciawiseTemplate',
      component: CreateFT,
    },
    {
      path: '/fasciawiseTemplates',
      name: 'fasciawiseTemplates',
      component: FasciawiseTemplates,
    },
    {
      path: '/prepareMailers',
      name: 'prepareMailers',
      component: PrepareMailers,
    },
    {
      path: '/CreateMailer',
      name: 'CreateMailer',
      component: CreateMailer,
    },
    {
      path: '/sliceToMailers',
      name: 'sliceToMailers',
      component: SliceToMailer,
    },
    {
      path: '/categoryList/',
      name: 'categoryList',
      component: categoryList,
    },
    {
      path: '/createcategory/*',
      name: 'createcategory',
      component: CreateCategory,
    },
    {
      path: '/custommailer/',
      name: 'custommailer',
      component: CustomMailerTemplates,
    },
    {
      path: '/createcustommailer/*',
      name: 'createcustommailer',
      component: CreateCustomMailer,
    },
    {
      path: '/invalidAccess/',
      name: 'invalidAccess',
      component: InvalidAccess,
    },
  ],
});
